export const cousresArray = [
  {
    title: "Introduction to Cognitive Psychology",
    category: ["Psychotherapy", "Psychotherapy", "Psychotherapy"],
    categoriesData: [
      "Psychotherapy",
      "Older Adults",
      "Kids",
      "Health Psychology",
      "Affirming/Anti-Racist Therapy",
      "Neuropsychology",
      "Testing",
    ],
    summary:
      "This course provides an overview of cognitive psychology, focusing on how the mind processes information, makes decisions, and forms memories. Students will explore key theories and research findings that have shaped our understanding of human cognition.",
    author: "Serra Orakargoz",
    createdAt: "04/20/2024",
    sourceOfKnowledge: "Clinical Insights",
    type: "Course",
    price: "$180 ",
    coverPhotoUrl: "/assets/icons/card1.png",
    profilePicture: "/assets/icons/card1.png",
  },
  {
    title: "Introduction to Cognitive Psychology",
    category: ["Psychotherapy", "Psychotherapy", "Psychotherapy"],
    summary:
      "This course provides an overview of cognitive psychology, focusing on how the mind processes information, makes decisions, and forms memories. Students will explore key theories and research findings that have shaped our understanding of human cognition.",
    author: "Serra Orakargoz",
    createdAt: "04/20/2024",
    sourceOfKnowledge: "Clinical Insights",
    type: "Course",
    price: "$180 ",

    coverPhotoUrl: "/assets/icons/card1.png",
    profilePicture: "/assets/icons/card1.png",
  },
  {
    title: "Introduction to Cognitive Psychology",
    category: ["Psychotherapy", "Psychotherapy", "Psychotherapy"],
    summary:
      "This course provides an overview of cognitive psychology, focusing on how the mind processes information, makes decisions, and forms memories. Students will explore key theories and research findings that have shaped our understanding of human cognition.",
    author: "Serra Orakargoz",
    createdAt: "04/20/2024",
    sourceOfKnowledge: "Clinical Insights",
    type: "Course",
    price: "$180 ",

    coverPhotoUrl: "/assets/icons/card1.png",
    profilePicture: "/assets/icons/card1.png",
  },
  {
    title: "Introduction to Cognitive Psychology",
    category: ["Psychotherapy", "Psychotherapy", "Psychotherapy"],
    summary:
      "This course provides an overview of cognitive psychology, focusing on how the mind processes information, makes decisions, and forms memories. Students will explore key theories and research findings that have shaped our understanding of human cognition.",
    author: "Serra Orakargoz",
    createdAt: "04/20/2024",
    sourceOfKnowledge: "Clinical Insights",
    type: "Course",
    price: "$180 ",

    coverPhotoUrl: "/assets/icons/card1.png",
    profilePicture: "/assets/icons/card1.png",
  },
  {
    title: "Introduction to Cognitive Psychology",
    category: ["Psychotherapy", "Psychotherapy", "Psychotherapy"],
    summary:
      "This course provides an overview of cognitive psychology, focusing on how the mind processes information, makes decisions, and forms memories. Students will explore key theories and research findings that have shaped our understanding of human cognition.",
    author: "Serra Orakargoz",
    createdAt: "04/20/2024",
    sourceOfKnowledge: "Clinical Insights",
    type: "Course",
    price: "$180 ",

    coverPhotoUrl: "/assets/icons/card1.png",
    profilePicture: "/assets/icons/card1.png",
  },
  {
    title: "Introduction to Cognitive Psychology",
    category: ["Psychotherapy", "Psychotherapy", "Psychotherapy"],
    summary:
      "This course provides an overview of cognitive psychology, focusing on how the mind processes information, makes decisions, and forms memories. Students will explore key theories and research findings that have shaped our understanding of human cognition.",
    author: "Serra Orakargoz",
    createdAt: "04/20/2024",
    sourceOfKnowledge: "Clinical Insights",
    type: "Course",
    price: "$180 ",

    coverPhotoUrl: "/assets/icons/card1.png",
    profilePicture: "/assets/icons/card1.png",
  },
  {
    title: "Introduction to Cognitive Psychology",
    category: ["Psychotherapy", "Psychotherapy", "Psychotherapy"],
    summary:
      "This course provides an overview of cognitive psychology, focusing on how the mind processes information, makes decisions, and forms memories. Students will explore key theories and research findings that have shaped our understanding of human cognition.",
    author: "Serra Orakargoz",
    createdAt: "04/20/2024",
    sourceOfKnowledge: "Clinical Insights",
    type: "Course",
    price: "$180 ",

    coverPhotoUrl: "/assets/icons/card1.png",
    profilePicture: "/assets/icons/card1.png",
  },
  {
    title: "Introduction to Cognitive Psychology",
    category: ["Psychotherapy", "Psychotherapy", "Psychotherapy"],
    summary:
      "This course provides an overview of cognitive psychology, focusing on how the mind processes information, makes decisions, and forms memories. Students will explore key theories and research findings that have shaped our understanding of human cognition.",
    author: "Serra Orakargoz",
    createdAt: "04/20/2024",
    sourceOfKnowledge: "Clinical Insights",
    type: "Course",
    price: "$180 ",

    coverPhotoUrl: "/assets/icons/card1.png",
    profilePicture: "/assets/icons/card1.png",
  },
  {
    title: "Introduction to Cognitive Psychology",
    category: ["Psychotherapy", "Psychotherapy", "Psychotherapy"],
    summary:
      "This course provides an overview of cognitive psychology, focusing on how the mind processes information, makes decisions, and forms memories. Students will explore key theories and research findings that have shaped our understanding of human cognition.",
    author: "Serra Orakargoz",
    createdAt: "04/20/2024",
    sourceOfKnowledge: "Clinical Insights",
    type: "Course",
    price: "$180 ",

    coverPhotoUrl: "/assets/icons/card1.png",
    profilePicture: "/assets/icons/card1.png",
  },
  {
    title: "Introduction to Cognitive Psychology",
    category: ["Psychotherapy", "Psychotherapy", "Psychotherapy"],
    summary:
      "This course provides an overview of cognitive psychology, focusing on how the mind processes information, makes decisions, and forms memories. Students will explore key theories and research findings that have shaped our understanding of human cognition.",
    author: "Serra Orakargoz",
    createdAt: "04/20/2024",
    sourceOfKnowledge: "Clinical Insights",
    type: "Course",
    price: "$180 ",

    coverPhotoUrl: "/assets/icons/card1.png",
    profilePicture: "/assets/icons/card1.png",
  },
  {
    title: "Introduction to Cognitive Psychology",
    category: ["Psychotherapy", "Psychotherapy", "Psychotherapy"],
    summary:
      "This course provides an overview of cognitive psychology, focusing on how the mind processes information, makes decisions, and forms memories. Students will explore key theories and research findings that have shaped our understanding of human cognition.",
    author: "Serra Orakargoz",
    createdAt: "04/20/2024",
    sourceOfKnowledge: "Clinical Insights",
    type: "Course",
    price: "$180 ",

    coverPhotoUrl: "/assets/icons/card1.png",
    profilePicture: "/assets/icons/card1.png",
  },
  {
    title: "Introduction to Cognitive Psychology",
    category: ["Psychotherapy", "Psychotherapy", "Psychotherapy"],
    summary:
      "This course provides an overview of cognitive psychology, focusing on how the mind processes information, makes decisions, and forms memories. Students will explore key theories and research findings that have shaped our understanding of human cognition.",
    author: "Serra Orakargoz",
    createdAt: "04/20/2024",
    sourceOfKnowledge: "Clinical Insights",
    type: "Course",
    price: "$180 ",

    coverPhotoUrl: "/assets/icons/card1.png",
    profilePicture: "/assets/icons/card1.png",
  },
];
